var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnunciarImovelImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578.04 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaeaea;}.cls-2{fill:#fafafa;}.cls-3{fill:#dfdfdf;}.cls-4{fill:#f5f5f5;}.cls-5{fill:#fff;}.cls-6{fill:#263238;}.cls-7{fill:#666;}.cls-8{fill:#60a9a5;}.cls-9{opacity:0.3;}.cls-10{fill:#e6c732;}.cls-11{fill:#de5177;}.cls-12{opacity:0.2;}.cls-13{fill:#ac91d0;}.cls-14{fill:#eebd9d;}.cls-15{fill:#80a3fc;}.cls-16{fill:#d79870;}.cls-17{fill:#455a64;}.cls-18{fill:#c3643b;}.cls-19{fill:#6283cc;}.cls-20{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vetores") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 354.91,
    y: 37.53,
    width: 141.76,
    height: 254.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 360.58,
    y: 44.91,
    width: 128.97,
    height: 239.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "502.67 294.48 496.67 292.19 496.67 33.21 502.67 33.21 502.67 294.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.19,199.74l33.5-31.14c4.24-3.94,9.79-8.19,15.25-6.25,2.62.94,4.6,3.18,7.17,4.25,5.14,2.15,11-.95,15-4.87s7.08-8.83,11.87-11.68,12.23-2.48,14.6,2.56v33.88l-48.68,20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.58,180.26c12.34-5,24.66-.75,33.49,9.23,1.86,2.1,3.55,4.52,6.11,5.68,3.46,1.57,7.46.4,11.23,0A28.25,28.25,0,0,1,438,208l-41.21,20.27L360.58,228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.55,180.43c-8.13-3.93-15.29.82-22.79,5.85s-14.47,11.47-23.26,13.49c-5.88,1.36-12.18.61-17.86,2.63-11.58,4.12-18.27,18.82-30.54,19.52-6.66.38-12.64-3.65-18.59-6.68s-10.63-5.91-15.93-1.86V284.6h129Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 360.58,
    y: 113.86,
    width: 131.77,
    height: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 360.58,
    y: 170.94,
    width: 131.77,
    height: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 360.58,
    y: 228.02,
    width: 131.77,
    height: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 336.93,
    y: 200.01,
    width: 176.26,
    height: 6.52,
    transform: "translate(221.8 628.33) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.41,
    y: 44.91,
    width: 2.95,
    height: 70.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 410.87,
    y: 44.91,
    width: 2.95,
    height: 70.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 436.33,
    y: 44.91,
    width: 2.95,
    height: 70.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 461.79,
    y: 44.91,
    width: 2.95,
    height: 70.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 348.92,
    y: 33.21,
    width: 6,
    height: 260.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 348.92,
    y: 30.58,
    width: 153.75,
    height: 6.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 344.66,
    y: 295.34,
    width: 162.06,
    height: 6.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "496.67 292.19 506.73 295.34 344.66 295.34 354.91 292.19 496.67 292.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.75,
    y: 41.32,
    width: 72.63,
    height: 105.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 120.11,
    y: 41.32,
    width: 72.63,
    height: 105.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 129.13,
    y: 52.72,
    width: 54.58,
    height: 82.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.71,135.19s0-.14,0-.4,0-.66,0-1.17c0-1,0-2.55,0-4.52,0-4,0-9.72,0-17,0-14.54-.05-35.14-.09-59.39l.18.18-54.57,0h0l.2-.2c0,31.11,0,59.8,0,82.47l-.16-.15,39.73.08,11,0,2.88,0h1l-1,0-2.85,0-10.94,0-39.83.08H129v-.16c0-22.67,0-51.36,0-82.47v-.19h55v.18c0,24.3-.06,44.94-.08,59.51,0,7.26,0,13-.05,16.94,0,2,0,3.46,0,4.49,0,.5,0,.88,0,1.15S183.71,135.19,183.71,135.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.94,41.32a13.23,13.23,0,0,1-1.29,1.88c-.85,1.13-2.05,2.67-3.41,4.33s-2.65,3.12-3.59,4.17a13.72,13.72,0,0,1-1.6,1.63,14,14,0,0,1,1.39-1.81l3.49-4.25c1.33-1.6,2.52-3.06,3.5-4.24A15.2,15.2,0,0,1,192.94,41.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184,134.93a67.38,67.38,0,0,0,9.52,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.51,146.83a10.74,10.74,0,0,1-1.66-1.51,53,53,0,0,1-3.59-4,50.76,50.76,0,0,1-3.16-4.39,11.22,11.22,0,0,1-1.11-1.95,14.83,14.83,0,0,1,1.34,1.79c.8,1.13,1.93,2.66,3.24,4.31s2.56,3.07,3.49,4.1A16.36,16.36,0,0,1,193.51,146.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.1,146.51l9.51-11.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.61,134.77a71.25,71.25,0,0,1-4.6,6,73.73,73.73,0,0,1-4.91,5.74,69.6,69.6,0,0,1,4.6-6C127.33,137.28,129.53,134.71,129.61,134.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.11,41.32a67.58,67.58,0,0,1,4.61,5.52A63.53,63.53,0,0,1,129,52.61a69.74,69.74,0,0,1-4.61-5.52A63.53,63.53,0,0,1,120.11,41.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 148.43,
    y: 69.47,
    width: 18.28,
    height: 51.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.25,
    y: 93.06,
    width: 57.42,
    height: 83.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 230.37,
    y: 93.06,
    width: 57.42,
    height: 83.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.5,
    y: 102.08,
    width: 43.16,
    height: 65.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.66,167.28s0-.11,0-.32V166c0-.82,0-2,0-3.58,0-3.12,0-7.68,0-13.43,0-11.5,0-27.78-.07-46.95l.14.14H237.5l.16-.15c0,24.59,0,47.27,0,65.2l-.13-.12,31.42.06,8.68,0,2.27,0h0l-2.26,0-8.65,0-31.49.07h-.12v-.13c0-17.93,0-40.61,0-65.2v-.16H280.8v.15c0,19.21-.05,35.52-.07,47,0,5.74,0,10.28,0,13.4,0,1.55,0,2.74,0,3.55,0,.4,0,.7,0,.91S280.66,167.28,280.66,167.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288,93.06a10,10,0,0,1-1,1.49c-.66.89-1.61,2.1-2.69,3.42s-2.09,2.47-2.84,3.3a10.17,10.17,0,0,1-1.26,1.28,10.66,10.66,0,0,1,1.09-1.43L284,97.77l2.76-3.36A9.49,9.49,0,0,1,288,93.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.88,167.07a52.9,52.9,0,0,0,7.53,9.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.41,176.48a8.07,8.07,0,0,1-1.31-1.19,40.12,40.12,0,0,1-2.84-3.2,37.88,37.88,0,0,1-2.5-3.48,9,9,0,0,1-.88-1.54,11.58,11.58,0,0,1,1.06,1.42c.63.89,1.52,2.1,2.56,3.4s2,2.44,2.76,3.25A13.43,13.43,0,0,1,288.41,176.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M230.36,176.23l7.52-9.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.88,167a55.94,55.94,0,0,1-3.64,4.74,56.34,56.34,0,0,1-3.88,4.54,58.62,58.62,0,0,1,3.64-4.74C236.08,168.93,237.82,166.9,237.88,167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.37,93.06A52.73,52.73,0,0,1,234,97.42a55.88,55.88,0,0,1,3.41,4.56,50.76,50.76,0,0,1-3.65-4.36A51.41,51.41,0,0,1,230.37,93.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.76,
    y: 115.31,
    width: 14.45,
    height: 41.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530.88,443.64c0,.15-101.95.26-227.67.26s-227.68-.11-227.68-.26,101.92-.26,227.68-.26S530.88,443.5,530.88,443.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M497.76,483.5c0,.15-49.76.26-111.13.26s-111.13-.11-111.13-.26,49.75-.26,111.13-.26S497.76,483.36,497.76,483.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M470.78,418.8a2.63,2.63,0,0,1,.17-.4c.13-.29.31-.68.55-1.17a30,30,0,0,0,1.61-4.68A41.38,41.38,0,0,0,473,394.5a96.63,96.63,0,0,0-3.35-12.13c-1.42-4.31-3.06-8.87-4.41-13.81A53.48,53.48,0,0,1,463,352.68c.21-5.61,1.87-11.22,3.7-16.8s3.71-11.05,4.28-16.54a25.19,25.19,0,0,0-3-15.28c-2.42-4.46-5.46-8.27-7.74-12.22a42.3,42.3,0,0,1-4.65-11.75,43.77,43.77,0,0,1-.3-18.21,34.06,34.06,0,0,1,1.9-6.42,2.9,2.9,0,0,1-.11.42c-.1.31-.23.72-.39,1.24a47.62,47.62,0,0,0-1.18,4.81A44.49,44.49,0,0,0,456,280a42.43,42.43,0,0,0,4.67,11.6c2.28,3.91,5.34,7.7,7.8,12.22a25.73,25.73,0,0,1,3.13,15.59c-.57,5.58-2.47,11.08-4.29,16.66s-3.47,11.13-3.68,16.65a53,53,0,0,0,2.13,15.71c1.32,4.91,2.95,9.48,4.35,13.8a95.79,95.79,0,0,1,3.29,12.2c1.53,7.6,1.1,14-.05,18.19a26.55,26.55,0,0,1-1.72,4.67l-.6,1.14A2.09,2.09,0,0,1,470.78,418.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M463.32,295.73s-4.62-14.79,3.68-23.46a.51.51,0,0,1,.88.26C468.32,275,468.87,282.41,463.32,295.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M466.1,277.2a14.71,14.71,0,0,1-.32,2.73c-.3,1.88-.66,4.09-1,6.53l-1,6.53a14.15,14.15,0,0,1-.49,2.7,12.12,12.12,0,0,1,.09-2.75c.15-1.69.45-4,.87-6.57s.86-4.85,1.22-6.51A12.09,12.09,0,0,1,466.1,277.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M468.76,330.63s2.83-15.24,14.22-19a.52.52,0,0,1,.66.64C482.88,314.62,479.89,321.45,468.76,330.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.87,315.55a13,13,0,0,1-1.55,2.27l-4,5.27-4,5.28a14.11,14.11,0,0,1-1.7,2.16,11.8,11.8,0,0,1,1.36-2.39c.93-1.42,2.28-3.34,3.85-5.4s3-3.88,4.12-5.18A13.11,13.11,0,0,1,479.87,315.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.68,368.87s-1.72-15.41,8.08-22.33a.52.52,0,0,1,.82.42C474.55,349.44,473.67,356.85,465.68,368.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M471.94,351.21a14.62,14.62,0,0,1-.83,2.62l-2.28,6.2c-.85,2.32-1.61,4.42-2.26,6.21a15.42,15.42,0,0,1-1,2.56,11.9,11.9,0,0,1,.61-2.69c.47-1.63,1.21-3.85,2.11-6.28s1.77-4.6,2.44-6.15A11.77,11.77,0,0,1,471.94,351.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M474.26,407.33s-1.17-15.46,8.88-22a.51.51,0,0,1,.8.44C483.81,388.23,482.67,395.61,474.26,407.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M481.14,389.9a12.72,12.72,0,0,1-.92,2.59c-.72,1.77-1.56,3.84-2.5,6.12s-1.76,4.36-2.48,6.13a14.7,14.7,0,0,1-1.09,2.52,11.88,11.88,0,0,1,.7-2.66c.54-1.62,1.35-3.82,2.34-6.21s1.93-4.53,2.66-6.06A12.71,12.71,0,0,1,481.14,389.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M456.67,282.73s-13.74-7.17-14-19.17a.51.51,0,0,1,.8-.44C445.51,264.53,451.17,269.4,456.67,282.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M445.52,267.68a14.66,14.66,0,0,1,1.71,2.15l3.87,5.36,3.89,5.34a15.56,15.56,0,0,1,1.57,2.26,11.19,11.19,0,0,1-1.89-2c-1.09-1.31-2.53-3.16-4-5.26s-2.82-4-3.74-5.47A11.42,11.42,0,0,1,445.52,267.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M471.43,314.51s-14.15-6.33-15.15-18.28a.52.52,0,0,1,.77-.5C459.18,297,465.12,301.53,471.43,314.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M459.38,300.16a14,14,0,0,1,1.84,2l4.19,5.11c1.57,1.9,3,3.63,4.21,5.09a14,14,0,0,1,1.69,2.16,12,12,0,0,1-2-1.88c-1.17-1.24-2.71-3-4.35-5s-3.06-3.85-4.06-5.22A12.16,12.16,0,0,1,459.38,300.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M463.29,350s-9.72-12.08-5.16-23.17a.51.51,0,0,1,.91-.09C460.35,328.8,463.58,335.53,463.29,350Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M459.09,331.69a13.55,13.55,0,0,1,.71,2.66c.4,1.86.88,4,1.4,6.46s1,4.59,1.43,6.45a15.64,15.64,0,0,1,.53,2.69,11.37,11.37,0,0,1-.93-2.59c-.48-1.63-1.05-3.9-1.59-6.43s-1-4.83-1.24-6.5A12.45,12.45,0,0,1,459.09,331.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M472.91,391.66s-14-6.56-14.84-18.53a.52.52,0,0,1,.78-.48C461,374,466.82,378.58,472.91,391.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M461.1,377.12a12.75,12.75,0,0,1,1.81,2.07l4.1,5.18,4.12,5.17a14.54,14.54,0,0,1,1.67,2.18,11,11,0,0,1-2-1.92c-1.14-1.25-2.66-3-4.26-5.07s-3-3.91-4-5.29A12.79,12.79,0,0,1,461.1,377.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.88,330.71s0,.12,0,.34,0,.6,0,1c0,.93-.1,2.18-.17,3.75L500,349.23h0v0c-1,5.61-3.86,11.83-7.69,17.86-2.82,4.45-5.77,8.49-8.32,12.25a88.05,88.05,0,0,0-6.23,10.3,44.05,44.05,0,0,0-2.91,7.56c-.25.93-.43,1.65-.54,2.14a4,4,0,0,1-.21.75,4.39,4.39,0,0,1,.1-.77c.07-.5.22-1.23.43-2.18a40.16,40.16,0,0,1,2.76-7.68,84.41,84.41,0,0,1,6.16-10.42c2.53-3.78,5.46-7.83,8.26-12.26,3.82-6,6.66-12.12,7.7-17.64v0c.39-5.51.71-10.11.94-13.41.13-1.57.23-2.82.31-3.75,0-.4.07-.72.09-1A1.66,1.66,0,0,1,500.88,330.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M492.52,366s6-14.32-1.53-23.7a.52.52,0,0,0-.9.18C489.43,344.84,488.2,352.2,492.52,366Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M491.44,347.27a12.22,12.22,0,0,1,.47,2.7c.21,1.69.45,4,.63,6.6s.27,4.92.27,6.62a11.65,11.65,0,0,1-.16,2.74,14.74,14.74,0,0,1-.25-2.73c-.12-1.9-.27-4.13-.44-6.59s-.32-4.7-.46-6.6A13.79,13.79,0,0,1,491.44,347.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.52,366s6-14.32-1.53-23.7a.52.52,0,0,0-.9.18C489.43,344.84,488.2,352.2,492.52,366Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M474.1,400.47s4.77-14.75-3.45-23.49a.51.51,0,0,0-.88.24C469.3,379.66,468.68,387.1,474.1,400.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M471.5,381.91a12.11,12.11,0,0,1,.69,2.67c.35,1.66.77,4,1.17,6.51s.67,4.89.81,6.58a11.1,11.1,0,0,1,.05,2.75,15.86,15.86,0,0,1-.46-2.7c-.28-1.88-.61-4.09-1-6.54s-.7-4.65-1-6.53A15,15,0,0,1,471.5,381.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.1,400.47s4.77-14.75-3.45-23.49a.51.51,0,0,0-.88.24C469.3,379.66,468.68,387.1,474.1,400.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M500.1,348.47s12.7-8.89,11.42-20.81a.52.52,0,0,0-.86-.34C508.82,329,503.84,334.54,500.1,348.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.1,348.47s12.7-8.89,11.42-20.81a.52.52,0,0,0-.86-.34C508.82,329,503.84,334.54,500.1,348.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M509.22,332.11a12.43,12.43,0,0,1-1.06,2.54c-.72,1.53-1.77,3.62-3,5.9s-2.41,4.3-3.32,5.73a11.9,11.9,0,0,1-1.62,2.23,14.78,14.78,0,0,1,1.26-2.44c.91-1.67,2-3.63,3.17-5.8s2.24-4.13,3.15-5.81A13.76,13.76,0,0,1,509.22,332.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M479.22,385.84s15.32-2.38,19.42-13.66a.51.51,0,0,0-.61-.67C495.64,372.19,488.72,375,479.22,385.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.22,385.84s15.32-2.38,19.42-13.66a.51.51,0,0,0-.61-.67C495.64,372.19,488.72,375,479.22,385.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M494.62,375.17a12.21,12.21,0,0,1-2.07,1.81c-1.32,1.06-3.19,2.48-5.29,4s-4.06,2.8-5.51,3.68a10.68,10.68,0,0,1-2.43,1.29,15.38,15.38,0,0,1,2.2-1.63l5.4-3.81c2-1.44,3.84-2.73,5.39-3.83A13,13,0,0,1,494.62,375.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "464.61 414.03 460.14 444.11 487.99 444.11 484.38 414.03 464.61 414.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485.49,423.35a109.06,109.06,0,0,1-11.23.29,109.06,109.06,0,0,1-11.23-.29,109.06,109.06,0,0,1,11.23-.29A109.06,109.06,0,0,1,485.49,423.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M486,425.75c0,.16-5.19.29-11.59.29s-11.6-.13-11.6-.29,5.19-.29,11.6-.29S486,425.59,486,425.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M474.2,483.48c2.53-15.73.15-32.4-7.73-46.25s-21.39-24.63-36.93-28.13-32.86.68-44.35,11.71c-13.1-1.48-26.57-1.32-39.16,2.57s-24.25,11.82-30.82,23.25-7.31,26.47-.26,37.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.51,407.89c0,.12-1.81.06-4.61.76l-1.09.29-1.16.41c-.8.25-1.61.66-2.49,1a30.58,30.58,0,0,0-5.22,3.29,32.51,32.51,0,0,0-4.42,4.33c-.56.77-1.16,1.45-1.59,2.18l-.68,1c-.18.35-.37.68-.54,1-1.36,2.54-1.77,4.31-1.89,4.27a6.35,6.35,0,0,1,.29-1.23c.05-.21.12-.43.18-.66s.19-.49.3-.75a13.23,13.23,0,0,1,.79-1.8c.17-.33.35-.67.53-1s.43-.69.65-1.06a26,26,0,0,1,1.59-2.24,31.21,31.21,0,0,1,4.46-4.44A29.74,29.74,0,0,1,413,410a25.39,25.39,0,0,1,2.55-1l1.19-.39,1.12-.26a15.15,15.15,0,0,1,1.94-.33l.81-.1h.68A5.34,5.34,0,0,1,422.51,407.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.9,425.53a.89.89,0,0,1-.23,0l-.69.08c-.61.07-1.51.11-2.65.27a62.9,62.9,0,0,0-9.59,1.9c-2,.53-4.13,1.27-6.4,2.12a67.93,67.93,0,0,0-7,3.28,62.6,62.6,0,0,0-14.21,10.51,71.38,71.38,0,0,0-6.07,6.88,68.93,68.93,0,0,0-4.71,7.13,60.26,60.26,0,0,0-7.47,22.92c-.16,1.14-.18,2-.26,2.65,0,.28-.05.5-.07.69a.89.89,0,0,1,0,.23.82.82,0,0,1,0-.23c0-.19,0-.42,0-.7,0-.61,0-1.51.16-2.66A55.67,55.67,0,0,1,325.4,471a59.11,59.11,0,0,1,5.52-13.47,65.91,65.91,0,0,1,4.73-7.21,69.83,69.83,0,0,1,6.1-6.94A62,62,0,0,1,356.1,432.8a65.4,65.4,0,0,1,7.08-3.26,63.81,63.81,0,0,1,6.47-2.08,59,59,0,0,1,9.66-1.74c1.15-.13,2.05-.13,2.66-.18l.69,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M428.35,414.15a5.36,5.36,0,0,1-.78,0c-.51,0-1.26-.05-2.22,0a33.69,33.69,0,0,0-8,1.33,34.65,34.65,0,0,0-10.77,5.27,32.65,32.65,0,0,0-5.29,4.72,30.46,30.46,0,0,0-4.43,6.18l-.64,1.2-.12.22-.23-.1A28.08,28.08,0,0,0,382,430.68a29.81,29.81,0,0,0-11.1,3.12,28,28,0,0,0-6.41,4.41c-1.35,1.26-2,2-2.06,2a4.76,4.76,0,0,1,.47-.58,18.49,18.49,0,0,1,1.45-1.56,26.61,26.61,0,0,1,6.38-4.59,31.58,31.58,0,0,1,5.05-2.08,31.94,31.94,0,0,1,6.18-1.19,28.34,28.34,0,0,1,14.15,2.33l-.34.13.66-1.22a30.4,30.4,0,0,1,4.5-6.28,33,33,0,0,1,5.39-4.76,34.38,34.38,0,0,1,10.95-5.24,31.51,31.51,0,0,1,8.11-1.17c1,0,1.72.06,2.22.07A3.73,3.73,0,0,1,428.35,414.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.93,436.77a27.19,27.19,0,0,1,12.71-17.08c6.29-3.5,13.57-4.89,20.76-5.2,4.42-.2,9.16.09,12.73,2.71,0,0-9.34,3.34-16.16,15.58A27.34,27.34,0,0,0,365.93,436.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.29,484.23a2.2,2.2,0,0,1-.18-.58l-.42-1.7c-.09-.38-.18-.79-.29-1.24s-.15-.95-.23-1.49a36.62,36.62,0,0,1-.42-3.65c0-.69-.08-1.4-.12-2.14s0-1.52,0-2.32A47.1,47.1,0,0,1,366,466a53.51,53.51,0,0,1,2.86-11.37,55.13,55.13,0,0,1,5.4-10.4l1.52-2.15c.48-.71,1.06-1.31,1.55-1.94s1-1.24,1.51-1.77l1.48-1.54c.92-1,1.89-1.78,2.68-2.52a23.47,23.47,0,0,1,2.15-1.76l1.41-1a3.49,3.49,0,0,1,.51-.34,2.72,2.72,0,0,1-.45.42l-1.34,1.12a24,24,0,0,0-2.08,1.82c-.78.75-1.72,1.53-2.61,2.55l-1.45,1.56c-.51.53-1,1.16-1.47,1.77s-1.05,1.24-1.52,1.94l-1.49,2.15a51.47,51.47,0,0,0-8.19,21.56,49.35,49.35,0,0,0-.41,5.06c0,.8-.08,1.56,0,2.3s.06,1.45.09,2.12a35.12,35.12,0,0,0,.34,3.64c.07.53.11,1,.19,1.49s.17.86.24,1.23c.13.71.24,1.28.32,1.72A3.49,3.49,0,0,1,367.29,484.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.57,483.73a2.76,2.76,0,0,1-.47-.37l-1.29-1.13c-.56-.5-1.25-1.1-2-1.87s-1.64-1.59-2.49-2.62-1.86-2.1-2.8-3.37c-.47-.63-1-1.26-1.46-1.95s-1-1.41-1.46-2.14a68.74,68.74,0,0,1-5.38-10.18A85.28,85.28,0,0,1,397.78,440c-.38-2.64-.63-4.79-.73-6.28-.06-.7-.1-1.27-.13-1.72a2.11,2.11,0,0,1,0-.6,2.85,2.85,0,0,1,.11.59c.06.45.14,1,.23,1.71.17,1.48.47,3.62.9,6.25a90.78,90.78,0,0,0,5.57,20A69.86,69.86,0,0,0,409,470l1.42,2.13c.46.7,1,1.32,1.44,2,.91,1.27,1.87,2.36,2.73,3.38s1.71,1.87,2.41,2.66,1.38,1.41,1.92,1.93l1.22,1.2C420.45,483.56,420.59,483.72,420.57,483.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461.16,483.54a.76.76,0,0,1,0-.26v-3.6c0-2.48-.1-6.07-.56-10.48A77.37,77.37,0,0,0,457.46,454a58.82,58.82,0,0,0-8.33-17,49.33,49.33,0,0,0-6.51-7.36,41.57,41.57,0,0,0-7.38-5.39,38.57,38.57,0,0,0-14.64-4.8,34,34,0,0,0-10.42.44l-1.6.37c-.47.12-.85.24-1.16.33l-.72.2-.25.05.23-.1.7-.25c.31-.1.69-.25,1.15-.38l1.61-.41a32.56,32.56,0,0,1,10.5-.62,38.46,38.46,0,0,1,14.83,4.75,41.81,41.81,0,0,1,7.49,5.43,49.25,49.25,0,0,1,6.59,7.43,58.67,58.67,0,0,1,8.37,17.17,75.6,75.6,0,0,1,3,15.32,96,96,0,0,1,.39,10.52c0,1.24-.06,2.21-.09,2.86l-.05.75A.87.87,0,0,1,461.16,483.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.45,231.92a5.92,5.92,0,0,1-2.83-8.09c1.12-2,3.39-3.21,4.11-5.36a7.24,7.24,0,0,0-.53-4.89,21.47,21.47,0,0,1-1.69-4.72,4.42,4.42,0,0,1,1.67-4.44c2-1.2,4.59.2,6.15,1.93A15,15,0,0,1,315.59,220c-.55,2-1.53,3.95-2.17,6a8.69,8.69,0,0,0,0,6.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.78,210.31s.25.15.6.54a6.73,6.73,0,0,1,1.12,1.91A8,8,0,0,1,310,216a7.37,7.37,0,0,1-1.31,3.83,26.81,26.81,0,0,0-2.37,3.11,5.82,5.82,0,0,0-.6,3,8.51,8.51,0,0,0,.79,2.8,1.89,1.89,0,0,1-.49-.65,5.55,5.55,0,0,1-.67-2.11,6,6,0,0,1,.54-3.26,22.66,22.66,0,0,1,2.38-3.2,7.19,7.19,0,0,0,1.25-3.56,7.82,7.82,0,0,0-.39-3.1A12.16,12.16,0,0,0,307.78,210.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.35,209.92s.25.15.6.55a6.57,6.57,0,0,1,1.12,1.9,7.71,7.71,0,0,1,.52,3.26,7.34,7.34,0,0,1-1.31,3.82,26.64,26.64,0,0,0-2.36,3.11,5.75,5.75,0,0,0-.61,3,8.69,8.69,0,0,0,.79,2.79s-.23-.19-.49-.64a5.67,5.67,0,0,1-.67-2.12,5.92,5.92,0,0,1,.55-3.26,23.16,23.16,0,0,1,2.37-3.2,7.16,7.16,0,0,0,1.25-3.55,8,8,0,0,0-.38-3.1A12.14,12.14,0,0,0,311.35,209.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.53,187.89a3.28,3.28,0,0,0-1.58,2.45,4.92,4.92,0,0,0,.65,2.92,4.74,4.74,0,0,0,1.7,1.8,3.1,3.1,0,0,0,2.41.34,3.62,3.62,0,0,0,2.19-2.28,4.81,4.81,0,0,0-.74-5,3.44,3.44,0,0,0-4.73-.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M314.3,234.57c0-.08.3-.35,1-.6a7.1,7.1,0,0,1,3.18-.27,8,8,0,0,1,7,7.25,8.25,8.25,0,0,1-1.45,5.74,8.4,8.4,0,0,1-3.84,2.88,7.12,7.12,0,0,1-3.16.42c-.75-.08-1.13-.27-1.12-.36,0-.27,1.66,0,3.85-1.08a7.93,7.93,0,0,0,3.08-2.68,7.39,7.39,0,0,0-1-9.14,7.78,7.78,0,0,0-3.59-1.94C315.93,234.23,314.37,234.83,314.3,234.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M297.38,230.85l1.56,21.66a3.18,3.18,0,0,0,3.22,3l13.34-.25a3.17,3.17,0,0,0,3.12-3.17V230.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M285.74,245.16l12.47-6.23,6.29-.47,6-.54s.67,2.24-3.65,3.7c-3.5,1.18-6.72,2.2-6.72,2.2s1,5.91-2.28,9.17a23.36,23.36,0,0,1-6.44,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M85.76,202.77l21,195.31,95.84,23,97.43-28.26s12.19-94.92-69.63-106.31c0,0,3.89-82.72-27.45-96.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.77,191.78s.17.06.5.22a10.63,10.63,0,0,1,1.41.78,19.87,19.87,0,0,1,4.63,4.13c3.52,4.17,7,11.45,9.51,21s4.38,21.29,5.51,34.57a405.6,405.6,0,0,1,1.18,44l-.23-.26c2.45.36,4.95.63,7.45,1.08s5,.92,7.51,1.67a76.4,76.4,0,0,1,14.82,5.43A64.52,64.52,0,0,1,259.75,317l1.79,2,.89,1,.83,1,1.63,2.06,1.49,2.15c1,1.4,1.84,2.93,2.74,4.38l1.2,2.26.59,1.13.52,1.15a74.18,74.18,0,0,1,5.78,18.56,80.81,80.81,0,0,1,1.09,9.1,67.28,67.28,0,0,1,0,8.75v.15l-.15,0-43.41,11-12.08,3-3.18.78c-.72.17-1.1.24-1.1.24l1.08-.31,3.16-.84,12.06-3.15,43.36-11.2-.16.19a64.58,64.58,0,0,0,0-8.68,79.73,79.73,0,0,0-1.1-9.05A73.94,73.94,0,0,0,271,334.37l-.52-1.14-.59-1.12-1.18-2.24c-.9-1.44-1.71-3-2.73-4.35l-1.48-2.12-1.62-2-.82-1-.88-1-1.78-2a64,64,0,0,0-17.55-12.58,76.05,76.05,0,0,0-14.72-5.4c-2.47-.74-5-1.13-7.47-1.66s-5-.72-7.41-1.09l-.24,0v-.23a413.33,413.33,0,0,0-1.11-43.9c-1.09-13.27-2.86-25-5.39-34.53s-5.87-16.78-9.33-20.95a20.36,20.36,0,0,0-4.54-4.18,12.47,12.47,0,0,0-1.38-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.22,363a2,2,0,0,1,.12.54c.07.41.15.92.24,1.55.21,1.35.45,3.31.72,5.74.52,4.85,1,11.58,1.23,19s.09,14.2,0,19.08c-.08,2.38-.14,4.33-.19,5.77,0,.64,0,1.15-.07,1.57a2.22,2.22,0,0,1-.07.55,2.15,2.15,0,0,1,0-.55c0-.42,0-.94,0-1.57,0-1.44,0-3.4,0-5.78,0-4.88.06-11.62-.14-19.05s-.64-14.16-1.06-19c-.23-2.37-.42-4.31-.56-5.74-.06-.64-.1-1.15-.14-1.57A2.08,2.08,0,0,1,216.22,363Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.12,285.78a25.82,25.82,0,0,1-2.87,1.37c-1.79.81-4.23,2-6.87,3.39s-4.95,2.82-6.61,3.86A24.54,24.54,0,0,1,212,296a15.47,15.47,0,0,1,2.53-2,70.76,70.76,0,0,1,13.53-7.28A15.22,15.22,0,0,1,231.12,285.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.82,248.86a2.27,2.27,0,0,1-.21-.58c-.13-.44-.29-1-.5-1.7l-1.8-6.24a104.87,104.87,0,0,0-7.73-19.9A48.73,48.73,0,0,0,117,204.2a36.62,36.62,0,0,0-5.5-3.39c-1.37-.68-2.16-1-2.14-1.05a2.53,2.53,0,0,1,.59.19c.37.16.94.34,1.64.68a32,32,0,0,1,5.63,3.27,42,42,0,0,1,7.13,6.53,54,54,0,0,1,6.7,9.76,97.58,97.58,0,0,1,7.62,20.05c.74,2.65,1.28,4.8,1.65,6.29.16.71.3,1.28.4,1.72A2.59,2.59,0,0,1,140.82,248.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M149.09,200l4.08,47.39,23.74-1.89c.15-2.77,0-13.5,0-13.5s9.88-1.53,10-11.41c.06-4.79-.63-14.7-1.35-23.63a18.27,18.27,0,0,0-19.28-16.78h0A18.27,18.27,0,0,0,149.09,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M176.88,231.88A23,23,0,0,1,164,228.22s3.05,7.11,12.9,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.09,203.54a1.4,1.4,0,0,1-1.36,1.42,1.35,1.35,0,0,1-1.45-1.27,1.41,1.41,0,0,1,1.36-1.42A1.35,1.35,0,0,1,183.09,203.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.4,202c-.17.18-1.24-.61-2.76-.61s-2.63.77-2.79.58.09-.41.58-.77a3.88,3.88,0,0,1,2.23-.69,3.8,3.8,0,0,1,2.2.71C183.33,201.54,183.49,201.87,183.4,202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.23,203.9a1.41,1.41,0,0,1-1.36,1.42,1.35,1.35,0,0,1-1.45-1.27,1.41,1.41,0,0,1,1.36-1.43A1.36,1.36,0,0,1,168.23,203.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.48,202.24c-.17.18-1.24-.61-2.76-.6s-2.63.76-2.79.57.09-.41.58-.76a3.77,3.77,0,0,1,2.24-.69,3.68,3.68,0,0,1,2.2.71C168.41,201.82,168.57,202.16,168.48,202.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174,213.49a10.28,10.28,0,0,1,2.47-.44c.38,0,.75-.12.82-.38a2.05,2.05,0,0,0-.26-1.15l-1.15-3c-1.59-4.2-2.74-7.66-2.57-7.72s1.59,3.29,3.19,7.49c.38,1,.75,2,1.09,3a2.21,2.21,0,0,1,.2,1.52,1,1,0,0,1-.63.57,2.87,2.87,0,0,1-.66.09A9.72,9.72,0,0,1,174,213.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.53,214.54c.24,0,.25,1.63,1.65,2.8s3.17,1,3.18,1.22-.39.32-1.13.34a4.08,4.08,0,0,1-2.65-.92,3.62,3.62,0,0,1-1.29-2.35C169.23,214.94,169.41,214.53,169.53,214.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.88,196.29c-.15.41-1.67.22-3.45.43s-3.22.7-3.46.33c-.1-.17.15-.56.73-1a5.73,5.73,0,0,1,2.56-.9,5.67,5.67,0,0,1,2.7.32C168.61,195.77,168.94,196.1,168.88,196.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.84,197.56c-.26.35-1.31,0-2.57,0s-2.32.24-2.56-.13c-.11-.17.06-.52.52-.84a3.58,3.58,0,0,1,2.09-.57,3.54,3.54,0,0,1,2.05.7C182.81,197,183,197.4,182.84,197.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.81,189.19l-.06,0a7.74,7.74,0,0,0-2.88,5l0,.2c-.39,2.81-.32,5.68-.73,8.49a12.75,12.75,0,0,1-3.47,7.61c-.85.8-2.37,1.35-3.07.41a2.38,2.38,0,0,1-.35-1.29c-.53-6.8-2.39-12.83-2.37-19.94a6,6,0,0,1,2.48-4.88c1.49-1.07,3.31-2.18,5-1.39s3.79,3.88,5.08,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M152.42,204.49c-.17-.08-6.79-2-6.57,4.74s7,5.14,7,5S152.42,204.49,152.42,204.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M150.66,211.69s-.12.08-.31.18a1.21,1.21,0,0,1-.88,0,2.92,2.92,0,0,1-1.43-2.57,3.9,3.9,0,0,1,.27-1.7,1.37,1.37,0,0,1,.86-.93.61.61,0,0,1,.7.3c.1.19.06.33.1.34s.14-.12.08-.4a.8.8,0,0,0-.28-.41.87.87,0,0,0-.66-.15,1.63,1.63,0,0,0-1.19,1.08,3.92,3.92,0,0,0-.35,1.9,3,3,0,0,0,1.81,2.86,1.24,1.24,0,0,0,1.07-.22C150.65,211.85,150.68,211.7,150.66,211.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.07,184.51c-1.66-2.7,2.89-6.58,6.22-7.63s7.72.58,11,1.68c2.09.69,4.18,1.66,6.38,1.57A15.06,15.06,0,0,0,182,179a10.79,10.79,0,0,1,4.32-.86,4.08,4.08,0,0,1,3.55,2.26,2.54,2.54,0,0,1-1.71,3.44A3.32,3.32,0,1,1,189,190c1-.73,2.43.47,2.31,1.67a3.52,3.52,0,0,1-2.31,2.56c-2.81,1.23-6.1.84-9-.14s-5.62-2.51-8.51-3.57-7.72-2.94-10.62-1.92c-2.14.76-3.62,3.33-4.83,2.76a4.17,4.17,0,0,1-2.14-3,11.88,11.88,0,0,1,.14-3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M189,183.7c-.06,0-.35.5-1.08,1.28a9.19,9.19,0,0,1-3.75,2.42,8.51,8.51,0,0,1-6.43-.26c-2.3-1-4.27-3.09-6.53-5a14,14,0,0,0-7.58-3.64,7.8,7.8,0,0,0-6.46,2.23,5.92,5.92,0,0,0-1.53,4.37,4.72,4.72,0,0,0,.29,1.24,1.31,1.31,0,0,0,.22.39,10.87,10.87,0,0,1-.25-1.65,5.79,5.79,0,0,1,1.61-4,7.36,7.36,0,0,1,6.05-1.95,13.67,13.67,0,0,1,7.22,3.54c2.22,1.9,4.25,4,6.7,5.08a9.21,9.21,0,0,0,10.64-2.54,6.23,6.23,0,0,0,.7-1.06C188.93,183.85,189,183.71,189,183.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M150.7,204.19s.29-.18.54-.72a4.55,4.55,0,0,0,.34-2.45c-.15-2.17-2.07-4.51-2.32-7.51a6.75,6.75,0,0,1,.75-4,5.14,5.14,0,0,1,2.51-2.17,4.44,4.44,0,0,1,2.25-.31c.54.09.84.22.86.16a1.71,1.71,0,0,0-.8-.41,4.22,4.22,0,0,0-2.48.12,5.47,5.47,0,0,0-2.87,2.3,7.12,7.12,0,0,0-.88,4.4,12.45,12.45,0,0,0,1.3,4.26,12.59,12.59,0,0,1,1.21,3.26A5.18,5.18,0,0,1,150.7,204.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "283.51 388.02 286.79 443.64 291.31 443.64 293.33 388.02 283.51 388.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "201.71 414.93 204.98 470.55 209.5 470.55 211.53 414.93 201.71 414.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.11 396.67 111.38 443.64 115.9 443.64 117.92 396.67 108.11 396.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M152.07,239s-17,10.58-19.17,18.74c0,0-3.3,6.61,0,17.85s50.19,61.27,50.19,61.27L223,322,205.4,290.63s-4.88-46.18-6.6-48.76c-5.61-8.38-25.91-5-25.91-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M195,238.5c.93.56,37.39,14.49,37.39,14.49l53-8.54,6.91,14.7-43.69,17.41a34.85,34.85,0,0,1-20.49,1.65l-24.87-5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.42,291.21a8.52,8.52,0,0,1-.16-1.54c0-1-.17-2.41-.33-4.17-.32-3.52-1-8.35-1.89-13.68s-1.51-10.2-1.75-13.74c-.12-1.77-.19-3.2-.19-4.19a10.93,10.93,0,0,1,0-1.54,7.66,7.66,0,0,1,.17,1.53c.06,1,.18,2.41.34,4.17.34,3.52,1,8.35,1.9,13.69s1.52,10.19,1.75,13.73c.11,1.77.17,3.21.16,4.2A9.27,9.27,0,0,1,205.42,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.42,291.21a30.45,30.45,0,0,1-3.23.94c-2,.56-4.73,1.41-7.68,2.54S189,297,187.11,298a27.71,27.71,0,0,1-3,1.47,3,3,0,0,1,.73-.54c.49-.32,1.21-.75,2.12-1.25a58.21,58.21,0,0,1,7.38-3.43,59,59,0,0,1,7.78-2.41c1-.24,1.84-.41,2.41-.5A3,3,0,0,1,205.42,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.18,292.33a59.65,59.65,0,0,0-7.3,4,60.71,60.71,0,0,0-6.33,5.39,9.11,9.11,0,0,1,1.52-1.93,27.86,27.86,0,0,1,4.52-3.89,27.11,27.11,0,0,1,5.24-2.82A8.45,8.45,0,0,1,206.18,292.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M151.51,242.24c-.12-2.24-.25-4.49-.37-6.73a1.63,1.63,0,0,1,.25-1.21c.45-.52,1.29-.28,1.93,0a25.38,25.38,0,0,0,18.14,0,23.91,23.91,0,0,1,4.07-1.41,4.88,4.88,0,0,1,4.09.84c1.47,1.27,1.57,2.23,1.6,4.17.05,3.41,0,8.47-2.45,10.86-1.65,1.62-4,2.21-6.29,2.72-5.16,1.19-10.52,2.37-15.7,1.31a9.84,9.84,0,0,1-6-3.33c-1.91-2.55,0-5.6.66-8.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.23,235.88a3.28,3.28,0,0,1,.07.68c0,.52,0,1.16.06,1.94h0a6.75,6.75,0,0,1-.82,2.71,10.08,10.08,0,0,1-2.32,2.82,15.61,15.61,0,0,1-3.63,2.33,19.49,19.49,0,0,1-4.58,1.35,31.79,31.79,0,0,1-12.73-.37,11.06,11.06,0,0,1-3.58-1.49,3.63,3.63,0,0,1-.79-.71c-.14-.2-.21-.31-.19-.32a6.75,6.75,0,0,0,1.09.86,12.09,12.09,0,0,0,3.56,1.3,33.62,33.62,0,0,0,12.55.22,19.87,19.87,0,0,0,4.47-1.3,15.61,15.61,0,0,0,3.53-2.22,8.17,8.17,0,0,0,3.17-5.21v0c0-.78,0-1.42.07-1.94A2.13,2.13,0,0,1,181.23,235.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.54,246.23a3.74,3.74,0,0,1-.95-1.41,10.46,10.46,0,0,1-.38-8.07,3.86,3.86,0,0,1,.81-1.49,13.46,13.46,0,0,0,.52,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.49,247.37a4.44,4.44,0,0,1-1-1.44,11.14,11.14,0,0,1-.81-8.39,4.16,4.16,0,0,1,.76-1.61,17.9,17.9,0,0,0-.66,5.83A18.17,18.17,0,0,0,162.49,247.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.39,246.65a13.44,13.44,0,0,1-2-5.23,13.64,13.64,0,0,1-.23-5.6c.16,0,.12,2.5.74,5.49S169.53,246.59,169.39,246.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.75,244.34a12.18,12.18,0,0,1-.14-1.7,10.76,10.76,0,0,0-1.15-3.84,11,11,0,0,0-2.47-3.15c-.79-.68-1.35-1-1.31-1.09a3.86,3.86,0,0,1,1.54.8,9.48,9.48,0,0,1,2.71,3.2,9.39,9.39,0,0,1,1,4.06A3.92,3.92,0,0,1,176.75,244.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.08,248a1.16,1.16,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.56,290.06a1.13,1.13,0,1,0,.08-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.6,258.11a1.13,1.13,0,1,0,.08-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196,260.15a1.16,1.16,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.33,243.49a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.28,250.55a1.16,1.16,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.35,270.87a1.13,1.13,0,1,0,.08-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243,256.72a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.75,254.28a1.13,1.13,0,1,0,.08-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282,256.38a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.14,266.73a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.83,262.19a1.13,1.13,0,1,0,.08-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.19,265.64a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.5,281a1.1,1.1,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.33,274.34a1.09,1.09,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.92,292.36a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.92,248.07a1.1,1.1,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.71,289a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.39,276.5a1.16,1.16,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.65,311.55s0,.07.08.22.12.4.19.66c.16.58.39,1.44.63,2.56a33.07,33.07,0,0,1,.62,4.13,19.42,19.42,0,0,1-.28,5.54,13.08,13.08,0,0,1-1,3.09,9,9,0,0,1-2,2.91,5.88,5.88,0,0,1-3.38,1.74,5.44,5.44,0,0,1-3.85-1.18,10.89,10.89,0,0,1-2.75-3.2,22,22,0,0,1-1.88-3.94,43.42,43.42,0,0,1-2.07-8.9,264.09,264.09,0,0,1-2.42-31.87c-.06-4.09,0-7.4,0-9.69,0-1.14.08-2,.1-2.63,0-.27,0-.5,0-.68a.77.77,0,0,1,0-.23,1,1,0,0,1,0,.23c0,.19,0,.41,0,.68v2.64c0,2.28,0,5.59.11,9.67a292.29,292.29,0,0,0,2.56,31.8,43,43,0,0,0,2,8.8,22.51,22.51,0,0,0,1.82,3.87,10.53,10.53,0,0,0,2.62,3.06,4.91,4.91,0,0,0,3.51,1.11,5.42,5.42,0,0,0,3.13-1.59,8.78,8.78,0,0,0,1.93-2.77,13.06,13.06,0,0,0,1-3,19.62,19.62,0,0,0,.35-5.44,35.14,35.14,0,0,0-.53-4.11c-.21-1.12-.4-2-.53-2.58-.06-.26-.1-.48-.14-.67A.67.67,0,0,1,194.65,311.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.17,419.94l36.38,11.73,21.56-42.47h0a3.26,3.26,0,0,0-4.7-.33l-21.35,19.31L370,401.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.44,344.84,290,374.5,335,373.27a2.24,2.24,0,0,0,2.15-2.71h0a2.25,2.25,0,0,0-1.46-1.67l-27.1-9.54-4.47-21.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223,322s24.41-38.26,34.79-52.44c8.56-11.68,33-11.94,36.58,6.56,2.7,13.79,19.89,74.41,19.89,74.41l-33,3.89-11.08-39.21s-19.8,41.72-26.54,46.45S201.51,330,201.51,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.27,400.78l-82.75-37.91-89.1-34.72-27.06,8.71s13.32,32.89,17.24,37.64,34.71,8,34.71,8l53.81,11,83.18,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M304.58,367a4.77,4.77,0,0,1-.81-.26l-2.29-.87-8.39-3.25-27.64-10.81-27.69-10.7-8.41-3.19-2.28-.88c-.52-.21-.79-.33-.79-.34a4.06,4.06,0,0,1,.82.24l2.32.79c2,.68,4.9,1.73,8.47,3,7.13,2.61,16.94,6.34,27.75,10.56s20.55,8.1,27.59,10.95l8.33,3.4,2.25,1A6.08,6.08,0,0,1,304.58,367Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M273.85,328.15a8.65,8.65,0,0,1-.52-1.59c-.29-1-.68-2.55-1.16-4.42-.95-3.74-2.23-8.92-3.59-14.65s-2.56-10.93-3.38-14.7c-.42-1.89-.74-3.41-.95-4.47a7.56,7.56,0,0,1-.24-1.67s.17.57.44,1.62.66,2.63,1.1,4.44c.93,3.83,2.17,9,3.54,14.66s2.54,10.84,3.44,14.68c.41,1.82.74,3.32,1,4.46A13.17,13.17,0,0,1,273.85,328.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M268.9,305.76a7.23,7.23,0,0,1-2-1.1,25.77,25.77,0,0,1-7.42-7.81,7.71,7.71,0,0,1-1-2,64.94,64.94,0,0,0,4.68,6A66,66,0,0,0,268.9,305.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.47,208.78a3.87,3.87,0,0,0-2.87,1.83,4.16,4.16,0,0,0-.29,3.51c.24.64.8,1.29,1.48,1.19a1.25,1.25,0,0,0,.89-.71,3,3,0,0,0,.24-1.16,1.3,1.3,0,0,1,.17-.68,1.6,1.6,0,0,1,.49-.36,2.09,2.09,0,0,0-.11-3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.24,229.89a1.32,1.32,0,0,1,.09.29c.06.22.14.49.23.84.2.78.48,1.87.83,3.26s.78,3.17,1.28,5.17,1.08,4.31,1.59,6.88a36.73,36.73,0,0,1,.79,8.53,19,19,0,0,1-2.74,9.43,12,12,0,0,1-3.84,3.74,13.55,13.55,0,0,1-5.32,1.76,18.81,18.81,0,0,1-5.78-.32,23.09,23.09,0,0,1-5.6-2,18.86,18.86,0,0,1-8.35-8.05A41,41,0,0,1,152,249.07c-1.5-6.75-2.59-12.88-3.38-18s-1.3-9.37-1.61-12.27c-.15-1.45-.26-2.58-.32-3.35q0-.54-.06-.87a1.69,1.69,0,0,1,0-.3,1.19,1.19,0,0,1,.06.29c0,.23.07.51.12.87l.42,3.34c.37,2.89.92,7.08,1.76,12.23s2,11.27,3.48,18a40.65,40.65,0,0,0,3.4,10.18A18.37,18.37,0,0,0,164,267a22.74,22.74,0,0,0,5.47,2,18.4,18.4,0,0,0,5.62.32,13.28,13.28,0,0,0,5.11-1.67,11.65,11.65,0,0,0,3.7-3.59,18.63,18.63,0,0,0,2.71-9.18,36.27,36.27,0,0,0-.73-8.44c-.48-2.56-1-4.86-1.51-6.88l-1.19-5.19c-.31-1.4-.56-2.5-.73-3.28-.08-.36-.13-.64-.18-.86A.94.94,0,0,1,182.24,229.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M202.63,421.1c.82-22.06,1.84-47.6-4-68.86-3.19-11.57-7.75-23.44-16.94-31-12.4-10.2-32-12.05-48-11-1.16-24.49-4-46.81-12.55-69.73-3.19-8.56-7-17.07-12.82-24S94.74,203.3,85.76,202.8l21,195.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M218.69,416.44c.61-22.11-1.06-56.11-6.93-77.36-3.2-11.57-7.76-23.44-16.94-31-12.41-10.21-32-12.06-48-11-1.17-24.48-4-46.81-12.56-69.73-3.19-8.56-7-17.06-12.81-24s-26.75,0-35.73-.53L120.18,385l82.45,36.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.63,421.1c.82-22.06,1.84-47.6-4-68.86-3.19-11.57-7.75-23.44-16.94-31-12.4-10.2-32-12.05-48-11-1.16-24.49-4-46.81-12.55-69.73-3.19-8.56-7-17.07-12.82-24S94.74,203.3,85.76,202.8l21,195.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M135.24,253s-24.15,26-29.56,50a21.27,21.27,0,0,0,9.94,23h0a21.34,21.34,0,0,0,16.81,2.14l45.43-13.19-1-16.28-44,2.69,19.44-25.91,7.78-9-19-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.26,320.92a1.73,1.73,0,0,1,.37-.14l1.09-.35,4.15-1.27,14.93-4.43-.16.23c-.32-4.84-.68-10.37-1.07-16.29l.23.24c-2.46.12-5.16.32-7.85.5l-32.23,2.19-9.77.61-2.65.14-.7,0h-.23s.07,0,.23-.05l.69-.07,2.65-.24,9.76-.78c8.24-.63,19.63-1.48,32.22-2.34,2.71-.18,5.31-.38,7.93-.49h.21l0,.25c.36,5.92.7,11.45,1,16.29v.18l-.17,0-15,4.25-4.19,1.16-1.1.28A1.5,1.5,0,0,1,157.26,320.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.64,301.85a32.67,32.67,0,0,0-5.82-3.47,33.23,33.23,0,0,0-6.57-1.68,5.86,5.86,0,0,1,2,0,17,17,0,0,1,8.94,3.72A5.59,5.59,0,0,1,133.64,301.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.78,289.44a2.54,2.54,0,0,1,.32-.45l1-1.24c.85-1.07,2.09-2.63,3.54-4.6a73.76,73.76,0,0,0,4.74-7.17,25.76,25.76,0,0,0,2.12-4.56,12.3,12.3,0,0,0,.56-5.29,14.48,14.48,0,0,0-4.56-9.07,15.15,15.15,0,0,0-7.55-3.65,17.48,17.48,0,0,0-5.74,0c-1.34.22-2.07.47-2.08.42a1.9,1.9,0,0,1,.51-.21,14.79,14.79,0,0,1,1.54-.41A16.65,16.65,0,0,1,142,253a15.47,15.47,0,0,1,7.82,3.66,14.88,14.88,0,0,1,4.75,9.38,13,13,0,0,1-.59,5.5,26.84,26.84,0,0,1-2.19,4.64,69.56,69.56,0,0,1-4.86,7.15c-1.5,1.95-2.78,3.47-3.68,4.51-.45.52-.81.91-1.06,1.18A2.54,2.54,0,0,1,141.78,289.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M186.14,316.28c2.07-3.79,10.51-18.72,12.7-22.61a1,1,0,0,1,1.42-.33l9.83,6.46a1,1,0,0,1,.34,1.3l-11.68,22.24a1,1,0,0,1-1.37.4l-10.85-6.11A1,1,0,0,1,186.14,316.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.71,272.33a1.1,1.1,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.4,303.86a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.87,318.36a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.13,306.32a1.1,1.1,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.3,291.21a1.09,1.09,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.56,266.67a1.16,1.16,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.52,307.41a1.13,1.13,0,1,0,.08-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.89,286.65a1.17,1.17,0,1,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.25,322.67a1.09,1.09,0,1,0,.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.09,299.24a1.11,1.11,0,1,1-.12,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "177.33 300.08 195.23 300.08 205.87 309.79 199.83 322.67 187.88 313.14 178.07 313.21 177.33 300.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M205.87,309.79l.7,3.7a2.8,2.8,0,0,1-1.23,2.87l-1,.67.15.9a2.39,2.39,0,0,1-1.31,2.52l-1,.47v0a2.07,2.07,0,0,1-2.36,1.71h0l-.46-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M204.48,318.3a59.12,59.12,0,0,1-1.11-6.29,7.49,7.49,0,0,1,1,3.07A7.57,7.57,0,0,1,204.48,318.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M202.15,321.18c-.15,0-.37-.86-.62-1.93s-.43-2-.29-2,.54.78.8,1.89A3.64,3.64,0,0,1,202.15,321.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnunciarImovelImg);
export default __webpack_public_path__ + "static/media/anunciarImovelImg.48a2367444b763ca74d5b68743a13273.svg";
export { ForwardRef as ReactComponent };